import {Injectable} from '@angular/core';
import {CurrentUserViewModel} from '../models/current-user.view-model';
import {environment} from '../../../environments/environment';
import {FeatureFlagName, FeatureFlagsConfig} from './feature-flag.types';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private readonly featureFlags: FeatureFlagsConfig = environment.featureFlags;

  public isEnabled(flag: FeatureFlagName, _user?: CurrentUserViewModel | null): boolean {
    return this.featureFlags[flag] === true;
  }
}
